import client from 'js/utils/client';

const reviewMiddleware = store => next => action => {
  if (action.type === 'REQUEST_REVIEW') {
    client
      .get(`/services/get_selection/?is_order_preview=${true}`)
      .then(resp => {
        store.dispatch({
          type: 'RECEIVE_REVIEW',
          review: resp.data.subgroups
        });
        store.dispatch({
          type: 'GET_REVIEW_RESPONSE',
          response: true
        });
      })
      .catch(() => {
        store.dispatch({
          type: 'GET_REVIEW_RESPONSE',
          response: false
        });
      });
  }
  next(action);
};

export default reviewMiddleware;
